const translate = {
  upload_photo: {
    en: 'Upload Photo',
    es: 'Subir Foto',
    fr: 'Télécharger une photo',
    de: 'Foto hochladen',
    pt: 'Carregar Foto',
    pl: 'Prześlij zdjęcie',
    nl: 'Foto uploaden',
    el: 'Ανέβασμα Φωτογραφίας',
    cs: 'Nahrát fotografii',
    sv: 'Ladda upp foto',
    hu: 'Fotó feltöltése',
    da: 'Upload foto',
    fi: 'Lataa kuva',
    sk: 'Nahrať fotografiu',
    bg: 'Качване на снимка',
    hr: 'Učitaj fotografiju',
    lt: 'Įkelti nuotrauką',
    lv: 'Augšupielādēt fotoattēlu',
    et: 'Laadi foto üles',
    sl: 'Naloži fotografijo',
    ga: 'Uaslódáil Grianghraf',
    mt: 'Itella ritratt',
    cy: 'Llwytho Llun',
    ro: 'Încărcați fotografia',
    it: 'Carica foto',
    zh_cn: '上传照片',
    hi: 'फ़ोटो अपलोड करें',
    ar: 'رفع الصورة',
    bn: 'ছবি আপলোড করুন',
    ru: 'Загрузить фото',
    ja: '写真をアップロード',
    tr: 'Fotoğraf Yükle',
    ko: '사진 업로드',
    vi: 'Tải ảnh lên',
    id: 'Unggah Foto',
    th: 'อัพโหลดรูปภาพ',
    ms: 'Muat Naik Foto',
    ar_eg: 'تحميل الصورة',
    uk: 'Завантажити фото',
  },
  upload_new_photo: {
    en: 'Upload New Photo',
    es: 'Subir Nueva Foto',
    fr: 'Télécharger une nouvelle photo',
    de: 'Neues Foto hochladen',
    pt: 'Carregar Nova Foto',
    pl: 'Prześlij nowe zdjęcie',
    nl: 'Nieuwe foto uploaden',
    el: 'Ανέβασμα Νέας Φωτογραφίας',
    cs: 'Nahrát novou fotografii',
    sv: 'Ladda upp nytt foto',
    hu: 'Új fotó feltöltése',
    da: 'Upload nyt foto',
    fi: 'Lataa uusi kuva',
    sk: 'Nahrať novú fotografiu',
    bg: 'Качване на нова снимка',
    hr: 'Učitaj novu fotografiju',
    lt: 'Įkelti naują nuotrauką',
    lv: 'Augšupielādēt jaunu fotoattēlu',
    et: 'Laadi uus foto üles',
    sl: 'Naloži novo fotografijo',
    ga: 'Uaslódáil Grianghraf Nua',
    mt: 'Itella ritratt ġdid',
    cy: 'Llwytho Llun Newydd',
    ro: 'Încărcați fotografia nouă',
    it: 'Carica nuova foto',
    zh_cn: '上传新照片',
    hi: 'नई फ़ोटो अपलोड करें',
    ar: 'رفع صورة جديدة',
    bn: 'নতুন ছবি আপলোড করুন',
    ru: 'Загрузить новое фото',
    ja: '新しい写真をアップロード',
    tr: 'Yeni Fotoğraf Yükle',
    ko: '새 사진 업로드',
    vi: 'Tải ảnh mới lên',
    id: 'Unggah Foto Baru',
    th: 'อัพโหลดรูปภาพใหม่',
    ms: 'Muat Naik Foto Baru',
    ar_eg: 'تحميل صورة جديدة',
    uk: 'Завантажити нове фото',
  },
  upload_image: {
    en: 'Upload Image',
    es: 'Subir Imagen',
    fr: 'Télécharger une image',
    de: 'Bild hochladen',
    pt: 'Carregar Imagem',
    pl: 'Prześlij obraz',
    nl: 'Afbeelding uploaden',
    el: 'Ανέβασμα Εικόνας',
    cs: 'Nahrát obrázek',
    sv: 'Ladda upp bild',
    hu: 'Kép feltöltése',
    da: 'Upload billede',
    fi: 'Lataa kuva',
    sk: 'Nahrať obrázok',
    bg: 'Качване на изображение',
    hr: 'Učitaj sliku',
    lt: 'Įkelti vaizdą',
    lv: 'Augšupielādēt attēlu',
    et: 'Laadi pilt üles',
    sl: 'Naloži sliko',
    ga: 'Uaslódáil Íomhá',
    mt: 'Itella immaġni',
    cy: 'Llwytho Delwedd',
    ro: 'Încărcați imaginea',
    it: 'Carica immagine',
    zh_cn: '上传图片',
    hi: 'छवि अपलोड करें',
    ar: 'رفع الصورة',
    bn: 'ছবি আপলোড করুন',
    ru: 'Загрузить изображение',
    ja: '画像をアップロード',
    tr: 'Resim Yükle',
    ko: '이미지 업로드',
    vi: 'Tải hình ảnh lên',
    id: 'Unggah Gambar',
    th: 'อัพโหลดภาพ',
    ms: 'Muat Naik Imej',
    ar_eg: 'تحميل صورة',
    uk: 'Завантажити зображення',
  },
  upload_more_images: {
    en: 'Upload More Images',
    es: 'Subir Más Imágenes',
    fr: "Télécharger Plus d'Images",
    de: 'Mehr Bilder hochladen',
    pt: 'Carregar Mais Imagens',
    pl: 'Prześlij więcej obrazów',
    nl: 'Meer afbeeldingen uploaden',
    el: 'Ανέβασμα Περισσότερων Εικόνων',
    cs: 'Nahrát více obrázků',
    sv: 'Ladda upp fler bilder',
    hu: 'Tölts fel több képet',
    da: 'Upload flere billeder',
    fi: 'Lataa lisää kuvia',
    sk: 'Nahrať viac obrázkov',
    bg: 'Качване на още изображения',
    hr: 'Učitaj više slika',
    lt: 'Įkelti daugiau vaizdų',
    lv: 'Augšupielādēt vairāk attēlu',
    et: 'Laadi rohkem pilte üles',
    sl: 'Naloži več slik',
    ga: 'Uaslódáil Tuilleadh Íomhánna',
    mt: 'Itella Aktar Stampi',
    cy: 'Llwytho Mwy o Ddelweddau',
    ro: 'Încărcați mai multe imagini',
    it: 'Carica più immagini',
    zh_cn: '上传更多图片',
    hi: 'और छवियां अपलोड करें',
    ar: 'رفع المزيد من الصور',
    bn: 'আরও ছবি আপলোড করুন',
    ru: 'Загрузить больше изображений',
    ja: 'さらに画像をアップロード',
    tr: 'Daha Fazla Resim Yükle',
    ko: '더 많은 이미지 업로드',
    vi: 'Tải thêm hình ảnh lên',
    id: 'Unggah Lebih Banyak Gambar',
    th: 'อัพโหลดรูปภาพเพิ่มเติม',
    ms: 'Muat Naik Lebih Banyak Imej',
    ar_eg: 'تحميل المزيد من الصور',
    uk: 'Завантажити більше зображень',
  },
  image_hint: {
    en: 'Upload {format} image, Max size of {size}',
    es: 'Subir imagen {format}, tamaño máximo de {size}',
    fr: 'Télécharger une image {format}, taille maximale de {size}',
    de: '{format}-Bild hochladen, maximale Größe {size}',
    pt: 'Carregar imagem {format}, tamanho máximo de {size}',
    pl: 'Prześlij obraz {format}, maksymalny rozmiar {size}',
    nl: 'Upload {format}-afbeelding, maximale grootte van {size}',
    el: 'Ανέβασμα εικόνας {format}, μέγιστο μέγεθος {size}',
    cs: 'Nahrajte obrázek {format}, maximální velikost {size}',
    sv: 'Ladda upp {format}-bild, maxstorlek {size}',
    hu: '{format} kép feltöltése, max méret {size}',
    da: 'Upload {format}-billede, maks. størrelse {size}',
    fi: 'Lataa {format}-kuva, enimmäiskoko {size}',
    sk: 'Nahrajte obrázok {format}, maximálna veľkosť {size}',
    bg: 'Качване на {format} изображение, максимален размер {size}',
    hr: 'Učitajte {format} sliku, maksimalna veličina {size}',
    lt: 'Įkelkite {format} vaizdą, didžiausias dydis {size}',
    lv: 'Augšupielādēt {format} attēlu, maksimālais izmērs {size}',
    et: 'Laadi üles {format}-pilt, maksimaalne suurus {size}',
    sl: 'Naložite {format} sliko, največja velikost {size}',
    ga: 'Uaslódáil íomhá {format}, an méid uasta {size}',
    mt: "Itella immaġni {format}, daqs massimu ta' {size}",
    cy: 'Llwytho delwedd {format}, maint uchaf o {size}',
    ro: 'Încărcați imaginea {format}, dimensiunea maximă de {size}',
    it: 'Carica immagine {format}, dimensione massima di {size}',
    zh_cn: '上传 {format} 图片，最大大小为 {size}',
    hi: '{format} छवि अपलोड करें, अधिकतम आकार {size}',
    ar: 'رفع صورة {format}، الحجم الأقصى {size}',
    bn: '{format} ইমেজ আপলোড করুন, সর্বাধিক আকার {size}',
    ru: 'Загрузить изображение {format}, максимальный размер {size}',
    ja: '{format}画像をアップロード、最大サイズ{size}',
    tr: '{format} resim yükle, maksimum boyut {size}',
    ko: '{format} 이미지 업로드, 최대 크기 {size}',
    vi: 'Tải ảnh {format} lên, kích thước tối đa {size}',
    id: 'Unggah gambar {format}, ukuran maksimum {size}',
    th: 'อัพโหลดภาพ {format} ขนาดสูงสุด {size}',
    ms: 'Muat Naik Imej {format}, Saiz Maksimum {size}',
    ar_eg: 'تحميل صورة {format}، الحد الأقصى للحجم {size}',
    uk: 'Завантажте зображення {format}, максимальний розмір {size}',
  },
  error_message: {
    en: 'Invalid Image Format or Size!\n Please upload in {format} format and under size limit {size}',
    es: '¡Formato o tamaño de imagen no válido!\n Por favor, suba en formato {format} y bajo el límite de tamaño de {size}',
    fr: "Format ou taille d'image invalide !\n Veuillez télécharger au format {format} et sous la limite de taille de {size}",
    de: 'Ungültiges Bildformat oder -größe!\n Bitte laden Sie im {format}-Format und unter der Größenbegrenzung von {size} hoch',
    pt: 'Formato ou tamanho de imagem inválido!\n Por favor, carregue no formato {format} e abaixo do limite de tamanho de {size}',
    pl: 'Nieprawidłowy format lub rozmiar obrazu!\n Prześlij w formacie {format} i poniżej limitu rozmiaru {size}',
    nl: 'Ongeldig afbeeldingsformaat of -grootte!\n Upload in {format}-formaat en onder de grootte limiet van {size}',
    el: 'Μη έγκυρη μορφή ή μέγεθος εικόνας!\n Παρακαλώ ανεβάστε σε μορφή {format} και κάτω από το όριο μεγέθους των {size}',
    cs: 'Neplatný formát nebo velikost obrázku!\n Nahrajte ve formátu {format} a pod limit velikosti {size}',
    sv: 'Ogiltigt bildformat eller storlek!\n Ladda upp i {format}-format och under storleksgränsen {size}',
    hu: 'Érvénytelen képformátum vagy méret!\n Töltse fel {format} formátumban és a méretkorlát alatt {size}',
    da: 'Ugyldigt billedformat eller størrelse!\n Upload venligst i {format}-format og under størrelsesgrænsen {size}',
    fi: 'Virheellinen kuvan muoto tai koko!\n Lataa {format}-muodossa ja kokorajoituksen alle {size}',
    sk: 'Neplatný formát alebo veľkosť obrázka!\n Nahrajte vo formáte {format} a pod limitom veľkosti {size}',
    bg: 'Невалиден формат или размер на изображението!\n Моля, качете в {format} формат и под ограничението за размер от {size}',
    hr: 'Nevažeći format ili veličina slike!\n Učitajte u {format} formatu i ispod ograničenja veličine od {size}',
    lt: 'Neteisingas vaizdo formatas arba dydis!\n Įkelkite {format} formatu ir neviršykite {size} dydžio limito',
    lv: 'Nederīgs attēla formāts vai izmērs!\n Lūdzu, augšupielādējiet {format} formātā un zem izmēra ierobežojuma {size}',
    et: 'Vigane pildi formaat või suurus!\n Laadige üles {format}-vormingus ja suuruspiirangu alla {size}',
    sl: 'Neveljaven format ali velikost slike!\n Naložite v {format} formatu in pod velikostno mejo {size}',
    ga: 'Formáid Íomhá nó Méid Neamhbhailí!\n Uaslódáil i bhformáid {format} agus faoi theorainn mhéid {size}',
    mt: "Format jew daqs tal-immaġni mhux validu!\n Itella f'format {format} u taħt il-limitu tad-daqs {size}",
    cy: 'Fformat Delwedd neu Faint Annilys!\n Llwythwch mewn fformat {format} ac o dan derfyn maint o {size}',
    ro: 'Format sau dimensiune imagine nevalidă!\n Vă rugăm să încărcați în format {format} și sub limita de dimensiune de {size}',
    it: "Formato o dimensione dell'immagine non valida!\n Carica in formato {format} e sotto il limite di dimensione di {size}",
    zh_cn: '无效的图像格式或大小！\n 请上传 {format} 格式，大小不超过 {size}',
    hi: 'अमान्य छवि प्रारूप या आकार!\n कृपया {format} प्रारूप में अपलोड करें और आकार सीमा {size} से कम रखें',
    ar: 'تنسيق الصورة أو الحجم غير صالح!\n يرجى التحميل بتنسيق {format} وتحت الحد الأقصى للحجم {size}',
    bn: 'অবৈধ চিত্র বিন্যাস বা আকার!\n দয়া করে {format} বিন্যাসে এবং {size} আকারের সীমার মধ্যে আপলোড করুন',
    ru: 'Недопустимый формат или размер изображения!\n Пожалуйста, загрузите в формате {format} и размером не более {size}',
    ja: '無効な画像フォーマットまたはサイズです！\n {format}形式でアップロードし、サイズ制限{size}以下にしてください',
    tr: 'Geçersiz Görüntü Formatı veya Boyutu!\n Lütfen {format} formatında ve {size} boyut sınırının altında yükleyin',
    ko: '유효하지 않은 이미지 형식 또는 크기입니다!\n {format} 형식으로 업로드하고 크기 제한 {size} 이하로 업로드하세요',
    vi: 'Định dạng hoặc kích thước hình ảnh không hợp lệ!\n Vui lòng tải lên định dạng {format} và dưới giới hạn kích thước {size}',
    id: 'Format atau ukuran gambar tidak valid!\n Unggah dalam format {format} dan di bawah batas ukuran {size}',
    th: 'รูปแบบหรือขนาดภาพไม่ถูกต้อง!\n โปรดอัพโหลดในรูปแบบ {format} และขนาดไม่เกิน {size}',
    ms: 'Format atau saiz imej tidak sah!\n Sila muat naik dalam format {format} dan di bawah had saiz {size}',
    ar_eg: 'تنسيق الصورة أو الحجم غير صالح!\n يرجى التحميل بتنسيق {format} وتحت الحد الأقصى للحجم {size}',
    uk: 'Недійсний формат або розмір зображення!\n Завантажте у форматі {format} та менше за ліміт розміру {size}',
  },
}
export default translate
